import { LongPressContext } from 'global/cnr/contexts/LongPressContext';
import MotionDiv from 'global/motions/MotionDiv';
import FullPageWrapper from 'global/wrappers/FullPageWrapper';
import { _longPressDisplayTypes } from 'global/wrappers/LongPressWrapper';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import { useContext, useEffect } from 'react';
import { Modal } from 'semantic-ui-react';

const ModalOverlay = ({
  topperCaption,
  header,
  content,
  frameworkRef,
  handleCancel,
  closeOverlay,
  isSidebar,
  longPressDisplayType
}) => {

  const longPressContext = useContext(LongPressContext);
  const { longPress_handlers } = longPressContext ?? {}

  useEffect(() => {

    if (longPressDisplayType === _longPressDisplayTypes.partial) { return; }
    // if (!isOverlay) { return; }
    // Push a dummy history entry so back button can close modal
    window.history.pushState(null, '');

    const onPopState = () => {
      closeOverlay(); // close overlay when back button/swipe occurs
    };

    window.addEventListener('popstate', onPopState);

    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const handle_cancel = () => {
    switch (longPressDisplayType) {
      case _longPressDisplayTypes.full:
        longPress_handlers && longPress_handlers.handleCancel()
      // closeOverlay()
      default:
        handleCancel && handleCancel()
      // nothing
    }
  }

  const modal_main = () => <Modal
    onClose={() => handle_cancel()}
    onOpen={() => handle_cancel()}
    open={true}
    className={longPressDisplayType === _longPressDisplayTypes.partial ? 'lpw-modal overlay' : 'lpw-modal grd'}
    mountNode={frameworkRef?.current || null} // crucial: modal stays in wrapper 
  >
    <div className='header'>{header}</div>
    <div className='content'>{content}</div>
  </Modal>

  const wrapper_main = () => <Wrapper
    header={!topperCaption ? header : null}
    content={content}
    wrapperType={wrapperTypes.padded}
    css={{ container: 'app-dark-mode' }}
  />

  const fpw_main = () => <MotionDiv transition={{ duration: .2 }}>
    <FullPageWrapper
      topperCaption={topperCaption}
      content={wrapper_main()}
      handleCancel={handle_cancel}
      longPressDisplayType={longPressDisplayType}
      isSidebar={isSidebar}
    />
  </MotionDiv>

  switch (longPressDisplayType) {
    case _longPressDisplayTypes.full:
      return fpw_main()
    case _longPressDisplayTypes.partial:
      return modal_main()
    default:
      return modal_main()
  }
}

export default ModalOverlay
